import type { GameVersion } from '@/mocks/updates';

interface VersionDetailProps {
  version: GameVersion;
}

export default function VersionDetail({ version }: VersionDetailProps) {
  return (
    <div key={version.version} className="animate-fade-in overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="relative h-44 w-full overflow-hidden md:h-56">
        <img
          src={version.cover}
          alt={`原神 ${version.version} ${version.name}`}
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
        <div className="absolute bottom-4 left-5 right-5">
          <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-white">
            v{version.version}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-white md:text-3xl">
            {version.name}
          </h2>
          <p className="mt-1 text-xs text-white/80">上线时间 {version.date}</p>
        </div>
      </div>

      <div className="p-5 md:p-6">
        <p className="text-[15px] leading-8 text-foreground-700">{version.summary}</p>

        <div className="mt-5">
          <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
            <i className="ri-sparkling-2-line text-accent-500"></i>
            版本亮点
          </h3>
          <div className="flex flex-wrap gap-2">
            {version.highlights.map((item) => (
              <span
                key={item}
                className="rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs font-medium text-accent-800"
              >
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-5">
          {version.changes.map((group) => (
            <div key={group.category}>
              <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <span className="h-4 w-1 rounded-full bg-primary-500"></span>
                {group.category}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {group.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2.5 rounded-md bg-background-100 px-3.5 py-2.5 text-sm leading-7 text-foreground-700"
                  >
                    <i className="ri-checkbox-circle-line mt-1 text-primary-500"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}